"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _entityLite = require("./entity-lite");
var _utils = require("../utils");
var getDestinationForSite = function getDestinationForSite(_ref) {
  var sys = _ref.sys,
    fields = _ref.fields;
  var destinations = (0, _utils.getProp)(fields, 'destinations');
  var destination = destinations !== null && destinations !== void 0 && destinations.length ? destinations.find(function (dest) {
    var _dest$fields, _dest$fields$site;
    return (_dest$fields = dest.fields) === null || _dest$fields === void 0 ? void 0 : (_dest$fields$site = _dest$fields.site) === null || _dest$fields$site === void 0 ? void 0 : _dest$fields$site.includes(process.env.NEXT_PUBLIC_SITE);
  }) : null;
  var url = destination ? (0, _entityLite.createEntityLite)(destination).url : null;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    url: url
  };
};
var createMultiBrandLink = function createMultiBrandLink(_ref2, content) {
  var sys = _ref2.sys,
    fields = _ref2.fields;
  var _getDestinationForSit = getDestinationForSite({
      sys: sys,
      fields: fields
    }),
    id = _getDestinationForSit.id,
    url = _getDestinationForSit.url;
  var text = (content === null || content === void 0 ? void 0 : content.length) > 0 ? content.reduce(function (prev, curr) {
    return "".concat(prev).concat(curr.value);
  }, '') : '';
  return {
    contentType: 'contentLink',
    id: id,
    url: url,
    text: text,
    external: false
  };
};
var _default = createMultiBrandLink;
exports["default"] = _default;